export { FunnelLabel } from './FunnelLabel';
